// Comfortable or compact spacing: data-density on <html>, cached in cs-density for the first paint.
import type { Density } from "@cosmosai/shared";

/** A per-viewer cache read by public/theme-boot.js; the saved preference wins over it. */
export const DENSITY_KEY = "cs-density";

export const currentDensity = (): Density =>
  document.documentElement.getAttribute("data-density") === "compact" ? "compact" : "comfortable";

export function applyDensity(density: Density): void {
  document.documentElement.setAttribute("data-density", density);
  try {
    localStorage.setItem(DENSITY_KEY, density);
  } catch {
    // Storage blocked: the density lasts for this page only.
  }
}
